import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteMotorcyclePermissions extends BaseScenesPermissions {}

export default MultiquoteMotorcyclePermissions
